"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lockTotalCostOfOwnership = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.lockTotalCostOfOwnership = (0, graphql_tag_1.default) `
  mutation LockTcoMutation($tcoId: ID!) {
    lockTco(tcoId: $tcoId) {
      id
      errorMessage
      systemErrors {
        systemId
        error
      }
    }
  }
`;
//# sourceMappingURL=lock-total-cost-of-ownerhip.js.map